import $ from 'jquery';
import api from '../apiService';
$(document).ready(function () {
    if ($('.tinymce_claim_email_template').length > 0) {
        initializeTinyMCEWithFields();
    }

    async function initializeTinyMCEWithFields() {
        const fields = await fetchClaimFields();
        tinymce.init({
            selector: '.tinymce_claim_email_template',
            plugins: 'autoresize link image code',
            toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code | menuClaimFieldsButton',
            setup: function (editor) {
                editor.ui.registry.addMenuButton('menuClaimFieldsButton', {
                    text: 'Fields',
                    fetch: function (callback) {
                        const items = fields.map(function (item) {
                            return {
                                type: 'menuitem',
                                text: item,
                                onAction: function () { editor.insertContent(`{{ claim.${item} }}`); }
                            };
                        });
                        callback(items);
                    }

                });
            },
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
        });
    }
    async function fetchClaimFields() {
        let response = await api.getData(
            '/api/app/backpack/fetch-claim-fields'
        );
        return response.data.fields || [];
    }
    window.changeTinymce = async function changeTinymce() {
        const selectedValue = $('#template').val();
        const id = $('[name="id"]').val();

        let response = await api.getData(
            `/api/app/backpack/fetch-email-body`, { params: { template_id: selectedValue, claim_id: id } }
        );
        const txt = response.data.text || '';
        if (txt && tinymce.get('content')) {
            tinymce.get('content').setContent(txt);
        }
    };
});
